document.addEventListener('DOMContentLoaded', () => {
    const topBars = document.querySelectorAll('.js-topbar');
  
    for (const topBar of topBars) {
      const topBarItems = topBar.querySelectorAll('.js-topbar-item');
  
      if (topBarItems.length > 0) {
        // Initially remove the 'inert' attribute from the first item (the first top bar item)
        topBarItems[0].removeAttribute('inert');
  
        // Create a MutationObserver to monitor changes to the 'inert' attribute of the first item
        const observer = new MutationObserver(mutations => {
          for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'inert') {
              topBarItems[0].removeAttribute('inert');
            }
          }
        });
  
        // Start observing the first top bar item for changes to its attributes (like 'inert')
        observer.observe(topBarItems[0], { attributes: true });
  
        // Disconnect the observer after the first slide change to stop unnecessary monitoring
        topBar.addEventListener('sl-slide-changed', () => {
          observer.disconnect(); 
        });
      }
  
      for (const topBarItem of topBarItems) {
        // Create a MutationObserver to monitor changes to both 'inert' and 'class' attributes
        const observer = new MutationObserver(mutations => {
          for (const mutation of mutations) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'inert' &&
              topBarItem.classList.contains('--is-active')
            ) {
              topBarItem.removeAttribute('inert');
            }
  
            if (mutation.attributeName === 'class') {
              if (topBarItem.classList.contains('--is-active') && topBarItem.hasAttribute('inert')) {
                topBarItem.removeAttribute('inert');
              }
            }
          }
        });
  
        // Start observing each top bar item for changes to its attributes (like 'inert' or '--is-active')
        observer.observe(topBarItem, { attributes: true });
      }
    }
  });
  